import { Banner } from '@sunwebgroup/uds-ui/banner'
import { useQuery } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { ReadMore } from '@/scopes/common/components/ReadMore'
import { translationAPIClient } from '@/scopes/products/user-reviews/infrastructure/api/translations'
import styles from './TranslatedText.module.css'

export function TranslatedText({ children }: { children: string }) {
  const intl = useIntl()
  const {
    isLoading,
    data: translatedText,
    error,
  } = useQuery({
    queryKey: ['translated-reviews', children],
    queryFn: () => translationAPIClient.translate(children),
  })

  if (isLoading) {
    return (
      <div className={styles.textIsTranslating}>
        <ReadMore charactersShown={255} readMoreText={intl.formatMessage({ id: 'reviews_read_more_label' })}>
          {children}
        </ReadMore>
      </div>
    )
  }

  if (error) {
    return (
      <>
        <ReadMore charactersShown={255} readMoreText={intl.formatMessage({ id: 'reviews_read_more_label' })}>
          {children ?? ''}
        </ReadMore>
        <Banner color="danger" text={intl.formatMessage({ id: 'reviews_translation_error' })} size="S" />
      </>
    )
  }

  return (
    <ReadMore charactersShown={255} readMoreText={intl.formatMessage({ id: 'reviews_read_more_label' })}>
      {translatedText ?? ''}
    </ReadMore>
  )
}
